export default {
  'supply-list': ['supply_management']
}
